import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import CriarElementoItemModal from "./criar/CriarElementoItemModal.vue";
import EditarElementoItemModal from "./editar/EditarElementoItemModal.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { ElementoItemService } from "../../services/ElementoItemService";
import { ExercicioService } from "../../services/ExercicioService";
import TextField from "../../components/fields/textField/TextField.vue";

export default {
    name: "GerenciarElementosItens",
    components: {
        Breadcrumb,
        CriarElementoItemModal,
        EditarElementoItemModal,
        ActionButtons,
        StandardPagination,
        TextField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Elemento Itens',
                disabled: true
            }
        ],
        headers: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px' },
            { text: 'Código Elemento Item', align: 'center', value: 'codigo_elemento_item', width: '150px' },
            { text: 'Descrição Elemento Item', align: 'center', value: 'descricao', width: '300px' },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px' },
        ],
        filters: {
            codigoElementoItemFilter: '',
            descricaoElementoItemFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        showFilters: true,
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    created() {
        this.listarElementosItensPaginado();
        this.listarExerciciosSelect();
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarElementosItensPaginado();
        },
        'filters.codigoElementoItemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarElementosItensPaginado();
            }
        },
        'filters.descricaoElementoItemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarElementosItensPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarElementosItensPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarElementosItensPaginado();
            }
        }
    },
    methods: {
        async listarElementosItensPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ElementoItemService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os Elemento Items.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Elemento Items:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        // Métodos para o componente ActionButtons
        navigateToCreate() {
            this.$router.push('/elementos-itens/criar');
        },
        
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/elementos-itens/editar/${this.itemSelected[0].id}`);
            }
        },
        
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        
        async destroyElementosItens() {
            try {
                const ids = this.itemSelected.map(elementoItem => elementoItem.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("elementosItens[]", id);
                });

                const response = await ElementoItemService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os Elementos Itens.');
                }

                this.listarElementosItensPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os Elementos Itens:', error);
            }
        },
        async activateElementosItens() {
            try {
                const ids = this.itemSelected.map(elementoItem => elementoItem.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("elementosItens[]", id);
                });

                const response = await ElementoItemService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os Elemento Itens.');
                }

                this.listarElementosItensPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os Elemento Itens:', error);
            }
        },
        async deactivateElementosItens() {
            try {
                const ids = this.itemSelected.map(elementoItem => elementoItem.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("elementosItens[]", id);
                });

                const response = await ElementoItemService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os Elemento Itens.');
                }

                this.listarElementosItensPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os Elemento Itens:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        // Métodos para o componente StandardPagination
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarElementosItensPaginado();
        },
        
        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.codigoElementoItemFilter) {
                filter.append("codigo_elemento_item", this.filters.codigoElementoItemFilter);
            }
            
            if (this.filters.descricaoElementoItemFilter) {
                filter.append("descricao", this.filters.descricaoElementoItemFilter);
            }
            
            if (this.filters.exercicioFilter) {
                filter.append("exercicio", this.filters.exercicioFilter);
            }
            
            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },

        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        
        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text;
            }
            return text.substring(0, maxLength) + '...';
        },
        
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
    }
};
